import { render, staticRenderFns } from "./partnersSlider.vue?vue&type=template&id=4d380f1d&"
import script from "./partnersSlider.vue?vue&type=script&lang=js&"
export * from "./partnersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports